<template>
    <div class="group-settings">
        <div class="max-group">
            <b-form-group>
                <b-form-input
                    class="teacher-max-group-setting"
                    v-model="max"
                    @change="updateMax"
                    type="number"
                    :placeholder="$t('group_pair.max_number_groups')"></b-form-input>
            </b-form-group>
        </div>

        <div class="group-toggle">
            <b-form-group>
                <b-form-checkbox
                    class="apprentice-switch"
                    v-model="selected"
                    switch
                    @change="updateSelected"
                    :key="user.id"></b-form-checkbox>
            </b-form-group>
        </div>
    </div>
</template>

<script>
export default {
    name: 'design-2021-group-pair-index-add-teacher-add-input-modal',
    props: ['user'],
    data() {
        return {
            max: null,
            selected: false,
        };
    },
    mounted() {
        this.reset();
    },
    methods: {
        updateMax(value) {
            this.$emit('change', {
                user_id: this.user.id,
                max: parseInt(value),
                selected: this.selected,
            });
        },
        updateSelected(value) {
            this.$emit('change', {
                user_id: this.user.id,
                max: parseInt(this.max),
                selected: value,
            });
        },
        reset() {
            if (this.user.group_pair_teachers.length) {
                this.selected = true;
                this.max = this.user.group_pair_teachers[0].max;
            } else {
                this.max = null;
                this.selected = false;
            }
        },
    },
};
</script>

<style scoped lang="scss">
.group-settings {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;

    fieldset {
        margin-bottom: 0;
    }
}

.max-group {
    .teacher-max-group-setting {
        border: solid 1px $border-color;
        width: 100%;
        margin-bottom: map-get($grid-gutter-spacing, 'fifteen');
    }
}

.group-toggle {
    align-self: flex-start;

    .apprentice-switch {
        min-height: 18px;
    }
}

@media (min-width: map-get($grid-breakpoints, 'sm')) {
    .group-settings {
        flex-direction: row;
    }

    .max-group {
        .teacher-max-group-setting {
            width: 220px;
            margin-bottom: 0;
        }
    }

    .group-toggle {
        align-self: center;
        margin-left: map-get($grid-gutter-spacing, 'fifteen');
    }
}
</style>
